module.exports = __webpack_public_path__ + "static/interactive-d52c42e0897c2fd5fb80a51148571f60.png";